import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'

import { actions as InvitesActions } from 'data/invites'
import { actions as ContactUserActions } from 'data/contactUser'
import { getOrganization } from 'data/organizations/selectors'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import { convertTextToEmails, filterEmails } from './utils'
import { isPopularDomain } from 'data/users/selectors'

import { Text } from 'components/base'

import ClassicInvitationsForm from './Classic'
import BulkInvitationsForm, { MAX_INVITEES } from './Bulk'
import OAuthInvitationsForm from './OAuth'
import OpenInviteLink from 'components/Invitations/OpenInviteLink'
import Slack from './Slack'
import ProviderBulkImportButton from './ProviderBulkImportButton'

const enhance = compose(
  withState('inviteBulkText', 'setInviteBulkText', ''),
  withState('showInviteBulk', 'setShowInviteBulk', false),
  withState(
    'emails',
    'setEmails',
    ({ defaultEmails }) => defaultEmails || ['']
  ),
  withState('OAuthEmails', 'setOAuthEmails', ['']),
  connect(
    state => ({
      organization: getOrganization(state),
      isPopularDomain: isPopularDomain(state),
    }),
    {
      createInvites: InvitesActions.createInvites,
      fetchMyOrganizationContacts:
        ContactUserActions.fetchMyOrganizationContacts,
    }
  )
)

class SendInvitationsForm extends Component {
  static propTypes = {
    afterSubmit: PropTypes.func,
  }
  static defaultProps = {
    afterSubmit: () => {},
  }

  getAllEmails = () => {
    const { OAuthEmails, emails, inviteBulkText } = this.props
    return [
      ...filterEmails(emails),
      ...filterEmails(OAuthEmails),
      ...convertTextToEmails(inviteBulkText),
    ].slice(0, MAX_INVITEES)
  }

  onSubmit = () => {
    const {
      afterSubmit,
      createInvites,
      setEmails,
      setOAuthEmails,
      setInviteBulkText,
    } = this.props
    const allEmails = this.getAllEmails()
    if (allEmails.length > 0) {
      createInvites({ invites: allEmails.map(email => ({ email })) })
      setEmails([''])
      setInviteBulkText('')
      setOAuthEmails([])
      afterSubmit()
    }
  }

  handleOnContactsFetchedDone = () => {
    this.props.fetchMyOrganizationContacts()
  }

  render() {
    const {
      inviteBulkText,
      setInviteBulkText,
      children,
      showInviteBulk,
      emails,
      setEmails,
      OAuthEmails,
      setOAuthEmails,
      organization,
      isPopularDomain,
    } = this.props

    const proposeContactImport = !isPopularDomain

    return (
      <div>
        <OpenInviteLink />
        <div className="margin-top-large" />
        {Boolean(organization.inviteToken) && <Slack />}
        {showInviteBulk ? (
          <BulkInvitationsForm
            goBack={() => this.props.setShowInviteBulk(false)}
            inviteBulkText={inviteBulkText}
            setInviteBulkText={setInviteBulkText}
          />
        ) : (
          <div>
            <div className="scroll-y scrollable" style={{ maxHeight: 300 }}>
              <ClassicInvitationsForm setEmails={setEmails} emails={emails} />
              <OAuthInvitationsForm
                setEmails={setOAuthEmails}
                emails={OAuthEmails}
              />
            </div>
            <div className="margin-vertical-small flexbox flexbox-align-center">
              {proposeContactImport && (
                <div className="flexbox flexbox-align-center">
                  <Text.Corpus className="margin-right-smaller">
                    Bulk import with:
                  </Text.Corpus>
                  <TooltipOnHover
                    delayShow={200}
                    placement="top"
                    tooltipContent="Google suite"
                  >
                    <div>
                      <ProviderBulkImportButton
                        onContactsFetchedDone={this.handleOnContactsFetchedDone}
                        provider="google"
                      />
                    </div>
                  </TooltipOnHover>
                  <TooltipOnHover
                    delayShow={200}
                    placement="top"
                    tooltipContent="Slack"
                  >
                    <div>
                      <ProviderBulkImportButton
                        onContactsFetchedDone={this.handleOnContactsFetchedDone}
                        provider="slack"
                      />
                    </div>
                  </TooltipOnHover>
                </div>
              )}
              <Text.Action
                inline
                onClick={() => this.props.setShowInviteBulk(true)}
                className="margin-left-smaller"
              >
                or add many at once
              </Text.Action>
            </div>
          </div>
        )}
        {children &&
          children({
            getEmails: this.getAllEmails,
            onSubmit: this.onSubmit,
          })}
      </div>
    )
  }
}

export default enhance(SendInvitationsForm)
